import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { AuthService } from "../services/auth.service";

export const authGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);
  if (auth.isLoggedIn()) {
    return true;
  }

  const token = auth.getToken();
  if (token) {
    void auth.initialize();
    return true;
  }

  router.navigateByUrl("/auth");
  return false;
};
